import { ClipboardCheck, Clock, Building2, Megaphone, AlertOctagon } from "lucide-react";

const Section = ({ Icon, label, items, color }) =>
  items?.length ? (
    <div className="mb-2.5">
      <div className={`flex items-center gap-1.5 text-[9px] font-mono uppercase tracking-widest mb-1 ${color}`}>
        <Icon className="w-3 h-3" /> {label}
      </div>
      <ul className="space-y-1">
        {items.map((it, i) => (
          <li key={i} className="flex gap-1.5 text-[11px] text-atlas-foreground/90 leading-snug">
            <span className={`shrink-0 ${color}`}>›</span>
            <span>{it}</span>
          </li>
        ))}
      </ul>
    </div>
  ) : null;

// Decision-ready EOC response for a high-impact / imminent anomaly.
export const PlaybookBlock = ({ playbook, testId }) => {
  if (!playbook) return null;
  const { situation, immediate_actions, next_24h, agencies, public_message, disclaimer } = playbook;
  return (
    <div className="mb-4 border border-emerald-400/30 bg-emerald-400/[0.04] p-3" data-testid={testId}>
      <div className="flex items-center gap-1.5 mb-2">
        <ClipboardCheck className="w-3.5 h-3.5 text-emerald-300" />
        <span className="text-[10px] uppercase tracking-widest text-emerald-300/80 font-mono">
          Response Playbook · Decision Support
        </span>
      </div>
      {situation && (
        <p className="text-[11px] text-white/90 leading-snug mb-2.5 border-l-2 border-emerald-400/40 pl-2 py-0.5">
          {situation}
        </p>
      )}
      <Section Icon={AlertOctagon} label="Immediate (next hours)" items={immediate_actions} color="text-atlas-red" />
      <Section Icon={Clock} label="Next 24 hours" items={next_24h} color="text-atlas-orange" />
      <Section Icon={Building2} label="Activate agencies" items={agencies} color="text-sky-300" />
      {public_message && (
        <div className="mt-2 border border-white/10 bg-white/[0.03] p-2">
          <div className="flex items-center gap-1.5 text-[9px] font-mono uppercase tracking-widest text-atlas-cyan/70 mb-1">
            <Megaphone className="w-3 h-3" /> Draft public advisory
          </div>
          <p className="text-[11px] text-white/90 leading-snug italic">“{public_message}”</p>
        </div>
      )}
      {disclaimer && <p className="text-[9px] font-mono text-atlas-secondary/75 mt-2 leading-relaxed">{disclaimer}</p>}
    </div>
  );
};
